import Link from "next/link";

import { css } from "@/../styled-system/css";
import Mail from "@/assets/svg/mail.svg";
import MapPin from "@/assets/svg/map-pin.svg";
import Phone from "@/assets/svg/phone.svg";

import FooterAccordion from "./FooterAccordion";

const footerLinksContainerClass = css({
  display: "none",
  sm: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: "8",
  },
});

const columnContainerClass = css({
  display: "block",
  marginLeft: "0px",
  maxWidth: "12.5rem",
  md: {
    maxWidth: "280px",
  },
});

const footerHeaderClass = css({
  fontFamily: "inter",
  fontSize: "sm",
  fontWeight: "semibold",
  color: "gray.300",
  mb: "4",
});

const footerLinkClass = css({
  fontFamily: "inter",
  fontSize: "md",
  fontWeight: "bold",
  color: "gray.100",
});

const rowContainerClass = css({
  display: "flex",
  width: "100%",
  alignItems: "center",
  gap: "3.5",
  mb: "4",
  _first: {
    alignItems: "flex-start",
    verticalAlign: "top",
  },
  "& .icon": {
    stroke: "brandTeal",
    flex: "none",
  },
  sm: {
    mb: "3",
  },
});

const footerInfo = [
  {
    header: "Page",
    subhead: [
      { text: "Home", link: "/" },
      { text: "Catalog", link: "/catalog" },
      { text: "Profile", link: "/profile" },
    ],
  },
  // {
  //   header: "Support",
  //   subhead: [
  //     { text: "Teams", link: "/shop" },
  //     { text: "Career", link: "/contact" },
  //     { text: "Features", link: "/blog" },
  //     { text: "Benefits", link: "/about-us" },
  //   ],
  // },
  {
    header: "FAQ",
    subhead: [
      { text: "About Us", link: "/about-us" },
      { text: "Orders", link: "/orders" },
      { text: "Returns", link: "/faqs" },
      { text: "Contact Us", link: "/faqs#contact-us" },
    ],
  },
];

const contactInfo = [
  {
    text: "1 Broadway Cambridge, MA 02139 United States",
    icon: <MapPin className="icon" width="1.5rem" />,
  },
  {
    text: "support@solecit.co",
    icon: <Mail className="icon" width="1.5rem" />,
  },
  {
    text: "+01 816-301-4102",
    icon: <Phone className="icon" width="1.5rem" />,
  },
];

function FooterLinks() {
  return (
    <>
      <div className={css({ mb: "8", sm: { display: "none" } })}>
        <FooterAccordion />
      </div>
      <div className={footerLinksContainerClass}>
        {footerInfo.map((column, headerIndex) => (
          <div className={columnContainerClass} key={headerIndex}>
            <h6 className={footerHeaderClass}>{column.header}</h6>
            <div className={css({ display: "block" })}>
              {column.subhead.map((footerLink, subheadIndex) => (
                <div
                  key={subheadIndex}
                  className={css({
                    mb: "4",
                    sm: {
                      mb: "3",
                    },
                  })}
                >
                  <Link
                    href={footerLink.link}
                    key={subheadIndex}
                    className={footerLinkClass}
                    prefetch
                  >
                    {footerLink.text}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
        <div className={columnContainerClass}>
          <h6 className={footerHeaderClass}>Contact Us</h6>
          <div className={css({ display: "block" })}>
            {contactInfo.map((contact, index) => (
              <div key={index} className={rowContainerClass}>
                {contact.icon}
                <span
                  className={css({
                    fontSize: "md",
                    color: "gray.100",
                    fontFamily: "inter",
                  })}
                >
                  {contact.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default FooterLinks;
